<template>
    <div>
        <div class="card">
            <div class="card-header">
                <span v-if="title">
                    {{ title }}
                </span>
                <span
                    class="btn btn-sm btn-primary float-right"
                    @click="add('push')"
                >
                    <span class="fa fa-plus" /> Добавить
                </span>
            </div>
            <div
                v-if="list.length"
                class="card-body"
            >
                <div
                    v-for="(item, index) in list"
                    :key="index"
                    class="row pb-2"
                    style="position: relative;"
                >
                    <div class="input-group col col-md-12">
                        <input 
                            v-model="list[index]['name']"
                            class="form-control mr-1"
                            autocomplete="off"
                            :placeholder="keyplaceholder"
                            :type="type"
                            pattern="[\x00-\x7F]+"
                            required
                        >
                        <input 
                            v-model="list[index]['label']"
                            class="form-control ml-1"
                            autocomplete="off"
                            required
                            :placeholder="valueplaceholder"
                            :type="type"
                        >
                        <div class="float-right ml-4">
                            <span
                                class="btn btn-danger"
                                @click="list.splice(index, 1)"
                            >
                                <span class="fa fa-trash" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input
            v-model="json"
            type="hidden"
            autocomplete="off"
            :name="name"
            :required="required"
        >
    </div>
</template>

<script>
export default {
    name: 'DictInput',
    props: {
        val: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: 'quick_dates',
        },
        type: {
            type: String,
            default: 'text',
        },
        title: {
            type: String,
            default: '',
        },
        keyplaceholder: {
            type: String,
            default: '',
        },
        valueplaceholder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: true,
        },
    },
    data: function() {
        return { 
            list: [], 
            json: JSON.stringify([])
        }
    },
    watch: {
        list: {
            handler: function (val) {
                this.toJSON();
            },
            deep: true
        },
    },
    mounted: function() {
        if (this.val) {
            this.list = JSON.parse(this.val);
        }
    },
    methods: {
        toJSON: function() {
            let sanitized = [];
            for (let item of this.list){
                if (item['name'].trim() && item['label'].trim()) {
                    sanitized.push(item);
                }
            }
            this.json = JSON.stringify(sanitized);
        },
        add: function() {
            this.list.push({'name': '', 'label': ''});
        }
    },
}
</script>
